import { render, staticRenderFns } from "./TournamentsMlbb.vue?vue&type=template&id=27c35371"
import script from "./TournamentsMlbb.vue?vue&type=script&lang=js"
export * from "./TournamentsMlbb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports